<app-loader [Parent]="this"></app-loader>
@if (Model != null) {
  <div>
    <app-pageheader [Parent]="this">
      @if (this.Model.Device != null) {
        <actionbutton Icon="rotate" ButtonType="primary" (PerformAction)="ResetDevice()">Reset Device</actionbutton>
      }
      <form-edit-button routerLink="edit">Edit</form-edit-button>
    </app-pageheader>
    <app-tabs>
      <app-tab Title="Configuration">
        <div style="margin:0 !important;" class="columns">
          <div class="column is-6">
            <article class="panel">
              <div class="panel-block">
                <div>
                  <app-field Label="Name" class="control flex-center">{{Model.Name}}</app-field>
                  <app-field Label="Location" class="control flex-center">{{Model.LocationString}}</app-field>
                  <app-field Label="Awake Time" class="control flex-center">{{Model.WakeUpTime}} - {{Model.SleepTime}}</app-field>
                </div>
              </div>
            </article>
            @if (Model.GatewayAssignments.length > 0) {
              <article class="panel">
                <p class="panel-heading">Hardware Assignment History</p>
                <div class="panel-block">
                  <table class="table is-striped" style="width:100% !important">
                    <tr><th>Hardware Chip Id</th><th>Assigned Dates</th></tr>
                    @for (item of Model.GatewayAssignments; track item) {
                      <tr>
                        <td>{{item.ChipId}}</td>
                        <td>{{item.DateInstalledString}} - {{item.IsActive ? 'Now' : item.DateUninstalledString}}</td>
                      </tr>
                    }
                  </table>
                </div>
              </article>
            }
          </div>
          <div class="column is-6">
            <app-structureviewermaps [StructureId]="Model.ParkingLevelId" [SearchTerm]="Model.Id" StructureViewerForType="GatewayConfiguration" [Layers]="StructureViewerLayers" [ShowLevelSelect]="false"></app-structureviewermaps>
          </div>
        </div>
      </app-tab>
      @if (HardwareModel != null) {
        <app-tab Title="Hardware">
          <div style="margin:0 !important;" class="columns">
            <div class="column is-6">
              <article class="panel">
                <p class="panel-heading">Gateway {{HardwareModel.ChipId}}</p>
                <div class="panel-block">
                  <div>
                    <app-field Label="Chip Id" class="control flex-center">{{HardwareModel.ChipId}}</app-field>
                    <app-field Label="Installed On" class="control flex-center">{{HardwareModel.InstalledOnString}}</app-field>
                    <app-field Label="Status" class="control flex-center">{{HardwareModel.Status}}</app-field>
                    <app-field Label="Version" class="control flex-center">{{HardwareModel.VersionNumber}}</app-field>
                    <app-field Label="Most Recent Check-In" class="control flex-center">{{HardwareModel.LastCheckedInOnString}}</app-field>
                    <app-field Label="Apn" class="control flex-center">{{HardwareModel.Apn}}</app-field>
                    <app-field Label="Sim Card" class="control flex-center">{{HardwareModel.SimCardId}}</app-field>
                    <app-field Label="APN" class="control flex-center">{{HardwareModel.Apn}}</app-field>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </app-tab>
      }
      <app-tab Title="Hardware Messages">
        <app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="{{'messaging/GatewayConfiguration/hardwaremessages/'+Model.Id+'/searches'}}"
          [AllowEdit]="true" [EditAsModal]="true" [ModalComponentType]="HardwareMessageType" EditUrl="hardware/messages/:id" [Filters]="Filters">
          <app-filter-set>
            <div app-search-filter></div>
            <div app-date-filter [DateSearchProperty]="'ProcessedOn'"></div>
            <div app-search-button></div>
          </app-filter-set>
        </app-datalistview>
      </app-tab>
    </app-tabs>
  </div>
}